export function sendEmail({
  emails,
  ccEmails,
  subject,
  body,
}: {
  emails: string[];
  ccEmails?: string[];
  subject: string;
  body?: string;
}) {
  const encodedBody = body ? `&body=${encodeURIComponent(body)}` : "";
  const encodedCc = ccEmails?.length ? `&cc=${encodeURIComponent(ccEmails.join(","))}` : "";
  const url = `mailto:${emails.join(",")}?subject=${encodeURIComponent(subject)}${encodedCc}${encodedBody}`;
  window.open(url);
}
